var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 19.7603,10.687014 5.8518,2.2259642 c -0.23427,-0.14261 -0.50248,-0.2205 -0.77704,-0.22567 -0.27455,-0.00518 -0.54553,0.06256 -0.78506,0.19624 -0.23953,0.13367 -0.43895,0.32846 -0.57774,0.56432 C 3.57316,2.9967142 3.5,3.2651242 3.5,3.5384742 V 20.462114 c 2.2e-4,0.2733 0.07353,0.5415 0.21238,0.7773 0.13885,0.2357 0.33824,0.4304 0.57769,0.564 0.23944,0.1336 0.51032,0.2014 0.78478,0.1963 0.27447,-0.005 0.54264,-0.0827 0.77695,-0.2251 l 13.9085,-8.4611 c 0.226,-0.1375 0.4127,-0.3305 0.5422,-0.5604 0.1295,-0.23 0.1975,-0.4892 0.1975,-0.7528 0,-0.2636 -0.068,-0.5229 -0.1975,-0.7528 -0.1295,-0.23 -0.3162,-0.4229 -0.5422,-0.5605 z"
  })));
}

export default SvgPlay;